// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bid-periods{color:var(--N800)}`, "",{"version":3,"sources":["webpack://./src/common-client2/src/components/BidPeriods/BidPeriods.scss"],"names":[],"mappings":"AAAA,aACI,iBAAA","sourcesContent":[".bid-periods{\r\n    color: var(--N800);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
